import { Outlet } from "react-router";
import Navbar from "./components/navigation/Navbar";
import Sidebar from "./components/navigation/Sidebar";

const Layout = () => {

    return (
        <div style={{ maxHeight: '100dvh', height: '100dvh', display: 'flex', flexDirection: 'column' }}  >
            <Outlet />
        </div >

    );
}

export default Layout
